import { Injectable } from '@angular/core';
import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { differenceInYears, parseISO } from 'date-fns';

import { AgeRequirementService } from '~/core/services/activity/age-requirement.service';

@Injectable({
  providedIn: 'root',
})
export class MajorityValidator {
  constructor(private readonly ageRequirement: AgeRequirementService) {}

  public validateISODate(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const majority = +this.ageRequirement.tenantMajority;
      const date = control.value;

      if (!date) {
        return {
          invalidDate: true,
        };
      }

      const birthday = parseISO(date);

      if (differenceInYears(new Date(), birthday) < majority) {
        return {
          minor: true,
        };
      }

      return null;
    };
  }
}
